import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch  } from 'react-redux';
import {
  PaginationComponent,
  ViewTypes,
  Spinner,
  NoContentComponent,
} from "../../../../../Components";
import { bottomBoxComponentUpdate, GetParams } from "../../../../../Helper";
import { ViewTypesEnum,  LeadOperationTypeEnum  , LeadsClassTypesEnum   } from "../../../../../Enums";
import ProposalStartButton from "../../../SmartProposal/Utilities/ProposalThemeDialog/ProposalStartButton";
import { ActiveInquiryViewsEnum } from "../../../LeadsSalesView/LeadsSalesProfileManagementView/Sections/LeadInquiriesView/ActiveInquiryViewsEnum";
import {
  GetMatchingLeadsForUnitAPI,
  unitDetailsGet 
} from "../../../../../Services";
import { UnitMatchingWithLeadsCardsComponent} from './UnitMatchingWithLeadsCardsComponent' ;
import useSmartProposalActions from "../../../SmartProposal/Hooks/useProposalStart";

export const UnitMatchingWithLeadsComponent = ({
  parentTranslationPath,
  translationPath,
  unitId ,
  unitType  , 
  activeItem
}) => {
  const [filter, setFilter] = useState({
    pageSize: parseInt(localStorage.getItem("Pagination")) || 25,
    pageIndex: 0,
  });
  const [isSmartProposalActive, setIsSmartProposalActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [unitInfo, setUnitInfo] = useState(null);
  const [activeLead, setActiveLead] = useState(null);
  const [sendProposalAll, setSendProposalAll] = useState(false);
  const [checkedCards, setCheckedCards] = useState([]);
  const [checkedDetailedCards, setCheckedDetailedCards] = useState([]); 
  const [activeView, setActiveView] = useState(
        ActiveInquiryViewsEnum.MatchedUnit
    );
  const [unitFilter, setUnitFilter] = useState({
    propertyId: null,
    operationTypeId: null,
    unitTypeId: null,
    bedrooms: null ,
    price: null ,
  });
  const [leadData, setLeadData] = useState({
    result: [],
    totalCount: 0,
  });  
  const [allLeads, setAllLeads] = useState({
    result: [],
    totalCount: 0,
  });

    const [allLeadsData, setAllLeadData] = useState({
    result: [],
    totalCount: 0,
  });

  const GetMatchingLeadsForUnit = useCallback(async () => {
    setIsLoading(true);
    const result = await GetMatchingLeadsForUnitAPI(
      { filter, pageIndex: filter.pageIndex + 1, pageSize: filter.pageSize },
      unitFilter
    );
    if (!(result && result.status && result.status !== 200)) {
      setAllLeads({
        result: result.result,
        totalCount: result.totalCount,
      });
    } else {
      setAllLeads({
        result: [],
        totalCount: 0,
      });
    }

    setIsLoading(false);
  }, [filter, unitFilter]);

    const GetUnitDataAPI = useCallback(async () => {
      setIsLoading(true);
      const id = GetParams('id') ; 
      const result = await unitDetailsGet({ id  : id });
      if (!(result && result.status && result.status !== 200)) {
        setUnitInfo(result);
        setIsLoading(false);
      } else {
        setUnitInfo(result);
        setIsLoading(false);
      }

      setIsLoading(false);
    }, [unitId]);


  useEffect(() => {
    if(unitId)
     GetUnitDataAPI(unitId);
  }, [GetUnitDataAPI ,unitId]);

    useEffect(() => {
    if(unitFilter && unitFilter?.operationTypeId)
     GetMatchingLeadsForUnit();
  }, [unitFilter , filter]);

    useEffect(() => {
      if(unitInfo && unitInfo?.unitId) 
      {
      setUnitFilter({
      propertyId: unitInfo?.unit?.property_name?.id,
      operationTypeId: (unitType === 'sale' || unitType === "leadOwnerUnitSale" ?  LeadOperationTypeEnum.buy.key  : LeadOperationTypeEnum.rent.key),
      unitTypeId: (unitInfo?.unit?.unit_type?.lookupItemId)  || null,
       bedrooms:  unitInfo?.unit?.bedrooms || null  ,
       price: (unitType === 'sale' ||  unitType === "leadOwnerUnitSale") ? unitInfo?.unit?.
          selling_price_agency_fee?.salePrice || null
            :    
            unitInfo?.unit?.rent_price_fees?.rentPerYear || null ,
        })

      }
  }, [unitInfo ,unitType]);

   useEffect(() => {
     if (allLeads && allLeads?.result && unitInfo?.unit) {
       const mapperList = allLeads?.result.map((l) => {
         const lead = l.leadJson ? JSON.parse(l.leadJson) : null;
         const leadData = {
           operationType:
             (l.leadClass === LeadsClassTypesEnum.buyer.key && "Sale") ||
             (l.leadClass === LeadsClassTypesEnum.tenant.key && "Rent"),
           unitTypes:
             lead?.lead?.propertyunit_type &&
             lead.lead.propertyunit_type
               .map((item) => item.lookupItemName)
               .join(", ") || 'N/A',
           property: (lead?.lead?.property_name) || 'N/A',
           bedrooms:
            (lead?.lead?.bedrooms &&
             Array.isArray(lead.lead.bedrooms) &&
             lead.lead.bedrooms.map((n) => n).join(", ")) ||  lead?.lead?.bedrooms || '' ,
           bathrooms:
             (lead?.lead?.bathrooms &&
             Array.isArray(lead.lead.bathrooms) &&
             lead.lead.bathrooms.map((n) => n).join(", ")) || lead?.lead?.bathrooms || '',
           budgetFrom: lead?.lead?.budgetFrom || '',
           budgetTo: lead?.lead?.budgetTo || '',
           leadType: lead?.lead?.lead_type_id || 2  , 
           leadClassName : lead?.lead?.leadClass  || null, 
         };
         delete l.leadJson;
         return {
           ...l,
           ...lead,
           unitId : GetParams('id') , 
           leadData,
         };
       });
       setAllLeadData({
         result: mapperList || [],
         totalCount: allLeads?.totalCount,
       });
     } else {
       setAllLeadData({
         result: [],
         totalCount: [],
       });
     }
   }, [allLeads, unitInfo]);

  const onPageIndexChanged = (pageIndex) => {
    setFilter((item) => ({ ...item, pageIndex }));
  };
  const onPageSizeChanged = (pageSize) => {
    setFilter((item) => ({ ...item, pageIndex: 0, pageSize }));
  };
  const [activeActionType, setActiveActionType] = useState(
    ViewTypesEnum.cards.key
  );
  const onTypeChanged = useCallback(
    (activeType) => {
      setActiveActionType(activeType);
    },
    [setActiveActionType]
  );

    useSmartProposalActions({ proposalLeads: checkedDetailedCards.length > 0  ?  checkedDetailedCards.map((item) => ({
         leadId: item?.leadId,
         lead: item?.lead,
         contactEmailAddress: (item?.lead?.contact_name?.email_address) ,        
         contactPhoneNumber: (item?.lead?.contact_name?.mobile || item?.lead?.contact_name?.phone),
         contactWhatsApp: (item?.lead?.contact_name?.mobile || item?.lead?.contact_name?.phone),
         unitId: (item?.unitId || GetParams('id')),
    }))  : [] ,
    proposalUnits : []
     
  });


   const getIsSelectedCard = useCallback(
      (itemIndex) =>
        checkedDetailedCards.findIndex((item) => item?.leadId === itemIndex) !== -1,
      [checkedDetailedCards]
    );

      const cardCheckboxClicked = useCallback((itemIndex, element) => {
        setCheckedDetailedCards((items) => {
          const index = items.findIndex((item) => item.leadId === element?.leadId);
          if (index !== -1) items.splice(index, 1);
          else items.push(element);
          return [...items];
        });
        setCheckedCards((items) => {
          const index = items.findIndex((item) => item=== element.leadId);
          if (index !== -1) items.splice(index, 1);
          else items.push(element.leadId);
          return [...items];
        });
      }, []);


       

    

  useEffect(() => {
    if(activeView !== ActiveInquiryViewsEnum.UnitOverview)
  bottomBoxComponentUpdate(
      <div className="bottom-box-two-sections">
        <PaginationComponent
          pageIndex={filter.pageIndex}
          pageSize={filter.pageSize}
          totalCount={allLeadsData.totalCount}
          onPageIndexChanged={onPageIndexChanged}
          onPageSizeChanged={onPageSizeChanged}
        />
      </div>
    );
    else  bottomBoxComponentUpdate(null);
  }, [leadData, filter , activeView , allLeadsData]);
  useEffect(
    () => () => {
      bottomBoxComponentUpdate(null);
    },
    []
  );
  return (
    <div className="lead-profile-units-wrapper px-0 pt-0 childs-wrapper">
      <div className="lead-profile-filter-section">
        <div className="filter-section-item px-0">
          <Spinner isActive={isLoading} isAbsolute />
          <div className="mt-2 mb-2 px-2">
            {allLeadsData.result?.length > 0 &&  ActiveInquiryViewsEnum.MatchedUnit === activeView &&  (
               <ProposalStartButton
                checkboxSelectHandler={(isActive) => {
                  setIsSmartProposalActive(isActive);
                     if (!isActive) {
                      setCheckedDetailedCards([]);
                      setCheckedCards([]);
                    }
                }}
                buttonType={
                  isSmartProposalActive ? "select-counter" : "select-outline"
                }
                singleUnit={activeItem}
                isLeadMatching={true}
                sendProposalToLead

              />
            )}
          </div>
          <div>
            <ViewTypes
              onTypeChanged={onTypeChanged}
              activeTypes={[
                // ViewTypesEnum.tableView.key,
                ViewTypesEnum.cards.key,
              ]}
              className="mb-3"
            />
          </div>
        </div>
      </div>
      {allLeadsData &&
        allLeadsData.result &&
        activeActionType === ViewTypesEnum.cards.key && (
          <div>
            {allLeadsData?.result && allLeadsData.result?.length > 0 && (
              <UnitMatchingWithLeadsCardsComponent
                parentTranslationPath={parentTranslationPath}
                translationPath={translationPath}
                data={allLeadsData}
                totalCount={allLeadsData.totalCount}
                saleMatching={unitType === "sale" ? true : false}
                activeLead={activeLead}
                setActiveLead={setActiveLead}
                activeView={activeView}
                setActiveView={setActiveView}
                unitInfo={unitInfo}
                activeItem={activeItem}
                isSmartProposalActive={isSmartProposalActive}
                setCheckedDetailedCards={setCheckedDetailedCards}
                getIsSelectedCard={(itemIndex)=> getIsSelectedCard(itemIndex)}
                setCheckedCards={setCheckedCards}
                onCardCheckboxClick={(itemIndex, element) => cardCheckboxClicked(itemIndex, element)}
              />
            )}
            {allLeadsData.totalCount === 0 && <NoContentComponent />}
          </div>
        )}
    </div>
  );
};
